/*
 *
 * Leader constants
 *
 */

export const GET_TEMPLATE_WATCHER =
  "app/ControlPanelUserManagementLeader/GET_TEMPLATE_WATCHER"
export const GET_TEMPLATE_FAILED =
  "app/ControlPanelUserManagementLeader/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS =
  "app/ControlPanelUserManagementLeader/GET_TEMPLATE_SUCCESS"
